import { DivConst } from 'constants/divConst';
import { getDivLabel } from 'utils/app';

import type { JSX } from 'react';

/**
 * 診断ステータス表示コンポーネント
 */
export default function DiagnosisStatusBadge(props: {
  diagnosisStatusDiv: number | null;
  size?: 'normal' | 'large';
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const getClassColor = (): string => {
    // 稼働
    if (DivConst.items.diagnosisStatus.published.value === props.diagnosisStatusDiv) {
      return 'diagnosis-status-published';
    }
    // 稼働（予約）
    else if (DivConst.items.diagnosisStatus.reserved.value === props.diagnosisStatusDiv) {
      return 'diagnosis-status-reserved';
    }
    // 未稼働
    return 'diagnosis-status-unpublished';
  };

  const getClassSize = (): string => {
    if (props.size === 'large') {
      return 'badge-common-lg ';
    }
    return '';
  };

  const getName = (): string => {
    if (props.diagnosisStatusDiv == null) {
      return '';
    }
    return getDivLabel('diagnosisStatus', props.diagnosisStatusDiv);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <span className={`badge badge-common ${getClassSize()} ${getClassColor()}`}>{getName()}</span>
    </>
  );
}
